import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import type { AppDispatch, RootState } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`

// export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useAppDispatch: () => AppDispatch = useDispatch // Export a hook that can be reused to resolve types

export const useAppSelector: TypedUseSelectorHook<RootState> = (selector, equalityFn) => {
  try {
    return useSelector(selector, equalityFn as any)
  } catch {
    return undefined as any
  }
}
